import type {Lambda} from 'mobx';

import {reaction} from 'mobx';

export interface WithReactionDispose {
  disposer: ReactionDisposeManager;
}

type DisposeFn = Lambda;

export class ReactionDisposeManager {
  private disposes: Map<string, DisposeFn>;

  constructor() {
    this.disposes = new Map<string, DisposeFn>();
  }

  dispose(key?: string) {
    if (key) {
      this.disposes.get(key)?.();
      this.disposes.delete(key);
    } else {
      this.disposes.forEach(dispose => dispose());
      this.disposes = new Map<string, DisposeFn>();
    }
  }

  watch(key: string, dispose: DisposeFn) {
    this.disposes.set(key, dispose);
  }

  watchMany<T = unknown>({
    condition = () => true,
    effect,
    reactionConfigs,
  }: {
    condition?: (arg: T) => boolean;
    effect: (arg: T, prev: T) => void;
    reactionConfigs: {
      expression: () => T;
      key: string;
    }[];
  }) {
    reactionConfigs.forEach(({expression, key}) => {
      this.watch(
        key,
        reaction<T>(
          expression,
          (arg, prev) => condition(arg) && effect(arg, prev),
        ),
      );
    });
  }
}
